import { createContext, useContext } from 'react';
import { useAppConfig } from '~/App/Api/AppConfig';
import type { FeatureDecisions } from '~/generated/FeatureDecisions';

export const defaultFeatureDecisions = {
  acceptsDiscounts: true,
  acceptsPaymentMethod: true,
  displayBonjoroGifInEmail: false,
  canDelegateTodos: false,
  canCustomiseLandingPage: false,
  canSetupLandingPageDomain: false,
  canAccessMultipleDesigns: false,
  canAccessTestimonials: false,
  canGreetMultipleProfiles: false,
  shouldHideBonjoroBranding: false,
  shouldHideBonjoroTestimonialBranding: false,
  canAccessProAutomations: false,
  canSendTeamInvites: false,
  canAccessNextGenTemplate: false,
  useSparkpost: false,
  canUseCampaigns: false,
  canRollupGreets: false,
  canAccessRecordings: false,
  canSetupLandingPageSubdomain: false,
  canPurchaseDomainAddOn: false,
  canPurchaseRollUpLimitAddOn: false,
  canPurchaseUserAddOn: false,
  canSchedule: false,
  canSendRollupsUsingOAuth: false,
  canSendRollupsUsingDefaultEmail: false,
  canAccessPublicApi: false,
  canAccessAutomationFilters: false,
  canAccessResendWorkflow: false,
  canSendViaWidget: false,
  canSwitchPlan: true,
  canAddAppSumoCode: false,
  videoMessageLimit: null,
  greetRollUpLimit: null,
  messageTemplateLimit: null,
  testimonialPublishablesLimit: null,
  automationLimit: null,
  freeUsersLimit: null,
  csvRowsLimit: null,
  testimonialPublishableAssetsLimit: null,
  shouldHideTestimonials: false,
} as FeatureDecisions;

export { FeatureDecisions };

export const FeaturesContext = createContext<FeatureDecisions>(
  defaultFeatureDecisions
);

export function useFeatures(): FeatureDecisions {
  const { data: appConfig } = useAppConfig();
  return appConfig?.user?.features ?? useContext(FeaturesContext);
}
